import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import ReportStep1 from '../PDFReports/AssessmentReportStep1';
import { Button, Icon, Message } from 'semantic-ui-react';
import { setPage, loadingEnd } from '../../redux/appSlice';

const useTitle = (title) => {
    useEffect(() => {
        const pervTitle = document.title;
        document.title = title;
        return () => {
            document.title = pervTitle;
        }
    })
}

const Step1ProjectPDF = () => {
    const projectState = useSelector(state => state.project);
    const appState = useSelector(state => state.app);
    const projectChecklists = useSelector(state => state.project.projectChecklists);
    const dispatch = useDispatch();
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const setError = (error) => {
        dispatch(setError(error));
    }   

    useTitle('STEP1-Report-'+projectState.project.customIdentifier);
    dispatch(loadingEnd());
    return (
        <div>
            <div className='menu'>
                <Button.Group>
                    <Button icon onClick={() => dispatch(setPage('Projects'))} color='blue' labelPosition='left'>
                        <Icon name='arrow left' />
                        Back
                    </Button>
                    <Button.Or />
                    <Button icon onClick={handlePrint} color='blue' labelPosition='right'>
                        <Icon name='print' />
                        Print
                    </Button>
                </Button.Group>
                
            </div>
            {appState.jems32 ? <Message warning><Message.Header>You're connected to Jems32 server.</Message.Header>Collected data may not reflect the live server please use <a href="http://jemsreports.nweurope.eu/" target="_blank" rel="noopener noreferrer">Jems Live Server</a></Message> : undefined}
            {/* <div><ProjectDetail ref={componentRef} projectState={projectState} projectChecklists={projectChecklists} setError={() => setError} /></div> */}
            <div><ReportStep1 ref={componentRef} projectState={projectState} projectChecklists={projectChecklists} setError={() => setError} /></div>
        </div>
    );
}

export default Step1ProjectPDF;